export default "__VITE_ASSET__DOiWRZJk__"